import { TailwindWrapper } from "@utils/TailwindWrapper";
import {
  Text,
  Accordion,
} from "@ui-component-library";

const templates = {
  DroneFAQ: {
    headerText: "Drönaranalys",
    faqData: [
      {
        question: "Vilka betalningsmetoder stödjer ni?",
        answer:
          "Du kan betala via Klarna eller faktura, vilket kan väljas när du går igenom processen för betalning på vår plattform.",
      },
      {
        question: "Vad är ett ortofoto?",
        answer:
          "Ett ortofoto är ett högupplöst flygfoto taget med drönare, som ger en exakt och aktuell bild av din skog från ovan. Till skillnad från satellitbilder är ortofoton mycket mer detaljerade och visar skogen precis som den ser ut - där träd, stigar, hyggen och andra detaljer framträder tydligt.",
      },
      {
        question: "Vad är ett ortofoto bra för?",
        answer:
          "Med en drönaranalys får du en tydlig överblick över hela din skogsfastighet i detalj – vilket gör det enklare att planera och följa upp ditt skogsbruk. Du kan uppdatera din skogsbruksplan med hög precision, utan att behöva gå ut i fält. Det gör det också lättare att planera smarta åtgärder, både inför och efter insatser som röjning, gallring, avverkning eller återplantering. Samtidigt sparar du både tid och pengar genom att slippa tidskrävande fältarbete i svår terräng.",
      },
      {
        question: "Hur gör man skadeinventering med hjälp av drönare?",
        answer:
          "Du kan välja att lägga till en skadeinventering till ditt ortofoto. Bilderna kommer då att analyseras för att identifiera exempelvis toppbrott eller angrepp från granbarkborre. Dessa områden kommer att vara utmarkerade, vilket gör det lätt för dig att se, undersöka och agera.",
      },
      {
        question: "Fördelar med skadeinventering med drönare?",
        answer:
          "Med hjälp av skadeanalys från drönare kan du upptäcka skador i tid – som granbarkborreangrepp som annars riskerar att sprida sig snabbt. Du får en tydlig bild av hur väderförhållanden påverkat skogen, till exempel genom toppbrott och snöskador efter stormar eller tungt snöfall. Det gör det lättare att prioritera rätt områden och rikta insatserna dit de gör störst nytta. Med en visuell rapport över skadeläget kan du agera proaktivt och planera åtgärder innan problemen växer sig stora – vilket sparar både resurser och skyddar virkesvärdet.",
      },
      {
        question: "Vad får jag om jag köper Skadeinventering Bas?",
        answer:
          "Denna analys går igenom din skog och markerar alla områden där det finns tecken på angrepp av granbarkborre. Alla områden kommer att vara tydligt markerade i din digitala skogsbruksplan så att du kan undersöka vidare.",
      },
      {
        question: "Vad får jag om jag köper Skadeinventering Plus?",
        answer:
          "I detta paket ingår, utöver skadeinventering för granbarkborre, även en inventering för toppbrott. Toppbrott och snöbrott är när toppen av träden har gått av, ofta på grund av kombinationer av stark vind och tung snö på toppen. Har du toppbrott i din skog bör du undersöka om det kräver en åtgärd, som exempelvis en gallring eller avverkning.",
      },
      {
        question: "Vad är ett snöbrott och vad borde jag veta om det?",
        answer:
          "Snöbrott är en sorts toppbrott som uppstår när tung, blöt snö samlas i träden, ofta i kombination med kyla och blåst. Det är främst unga och täta bestånd som drabbas, särskilt på höjder och i vindutsatta lägen. Tall är extra känslig, medan gran och björk ofta klarar sig bättre. Skadorna kan påverka både tillväxt och virkesvärde, och därför är det viktigt att sköta skogen med rätt röjning och gallring i tid. Efter ett snöfall bör du kontrollera skogen, särskilt där du nyligen gjort åtgärder. Om du hittar skador behöver de tas om hand snabbt för att undvika värdeförluster och angrepp från insekter.",
      },
      {
        question: "Kan jag köpa enbart en skadeanalys och inte ortofoto?",
        answer:
          "Nej, då analysen görs baserat på ortofotot så behöver du alltid köpa ett ortofoto. Olika analyser köps därefter som tillägg.",
      },
      {
        question:
          "Finns det några restriktioner gällande vilka som kan köpa en drönarflygning?",
        answer:
          "Ja, det krävs att drönarpiloten kan ta sig till fastigheten samt att det är tillåtet att flyga med drönare i området. Det är alltså inte möjligt att köpa en drönarflygning om din fastighet ligger på en ö eller i ett militärt område. Du måste även vara ägare till fastigheten eller ha tillstånd från ägaren.",
      },
      {
        question: "Var kan jag vända mig om jag har fler frågor?",
        answer:
          "Du är välkommen att kontakta oss på info@treebula.se så återkommer vi så snabbt vi kan.",
      },
    ],
  },
  GeneralFAQ: {
    headerText: "Vanliga frågor",
    faqData: [
      {
        question: "Vad kostar en skogsbruksplan hos Treebula?",
        answer:
          "Du kan skapa en digital skogsbruksplan helt utan kostnad. Den ger dig en bra grundöversikt över din skog. För dig som vill ha full kontroll erbjuder vi Treebula Plus, där planen uppdateras automatiskt och kompletteras med skogsövervakning, virkesprisdata, fastighetsvärdering och rådgivning – allt på ett ställe.",
      },
      {
        question:
          "Vad är Treebulas digitala skogsbruksplan, och hur skiljer den sig från en traditionell plan?",
        answer:
          "Treebulas digitala skogsbruksplan är ett smart digitalt verktyg som ger dig en alltid uppdaterad översikt över din fastighet. – Skillnaden: En traditionell plan är statisk och blir snabbt inaktuell. Vår plan är levande, den uppdateras kontinuerligt med ny data och du kan enkelt anpassa den efter dina egna mål och observationer. – Värde: Den ger dig full kontroll och tillgång till handlingskraftiga insikter om ekonomi, skötsel och miljö.",
      },
      {
        question: "Vilken data ingår i Skogsbruksplanen?",
        answer:
          "Planen ger dig tillgång till all viktig information du behöver för att fatta smarta beslut: – Skogsdata: Uppdaterade kartor, tillstånd, volymer och fördelningar av dina bestånd. – Ekonomi: Insyn i din fastighets värde, förväntade intäkter och kostnader. – Framtid: Riskanalyser (t.ex. för granbarkborre och brand) och insikter i din skogs klimatpåverkan. – Möjligheter: Rådgivning och verktyg för gallring, avverkning och nya intäktsmöjligheter, som att sälja kolkrediter.",
      },
      {
        question: "Hur ofta uppdateras informationen i Skogsövervakningen?",
        answer:
          "Vindfällen: var 2-3 vecka (sommartid). Granbarkborre: analyseras i september och oktober varje år. Väderdata: daglig uppdatering.",
      },
      {
        question: "Hur snabbt får jag veta om något händer i min skog?",
        answer: "Vi skickar en notis så snart akuta förändringar upptäcks.",
      },
      {
        question:
          "Hur säkerställer Treebula att jag får bästa pris för mitt virke och biobränsle?",
        answer:
          "Vi säkerställer bästa pris genom bred konkurrensutsättning. Vi tar in anbud från alla relevanta skogsbolag och köpare i ditt område. Eftersom vi agerar som en oberoende partner, har vi inget egenintresse i vem du väljer. Vårt uppdrag är att du ska förverkliga skogens rätta värden och få marknadens bästa pris.",
      },
      {
        question: `Vad innebär det att Treebula är en "oberoende partner"?`,
        answer:
          "Det innebär att vi står på din sida genom hela virkesaffären. Vi tror på ett rättvist och transparent skogsbruk. Vi agerar som en neutral partner mellan dig och virkesköparna, vilket skapar balans i affären. Du behåller full kontroll över alla beslut och villkor gällande din försäljning.",
      },
      {
        question: "Var kan jag vända mig om jag har fler frågor?",
        answer:
          "Du är välkommen att kontakta oss på 08 - 33 99 44 eller info@treebula.se så återkommer vi så snabbt vi kan.",
      },
    ],
  },
};

const FAQSection = (props) => {
  const selectedTemplate = props.template || "GeneralFAQ";
  const template = templates[selectedTemplate] || templates.GeneralFAQ;
  
  const headerText = template.headerText || "Vanliga frågor";

  return (
    <TailwindWrapper>
      <section className="w-full py-5 bg-white container">
        <div className="flex flex-col items-start gap-4 lg:gap-16 lg:flex-row py-3 lg:py-24">
          <div className="w-full flex flex-col gap-8 justify-between">
            <Text tw variant="overlineLargeRegular" className="text-[#737373]">
              {props.sectionName}
            </Text>
            <Text tw variant="text-3xl/leading-normal/medium">
              {props.title}
            </Text>
            <Text
              tw
              className="text-[#737373]"
              variant="text-base/leading-normal/normal"
            >
              {props.text}
            </Text>
          </div>
          {/* FAQ */}
          <div className="w-full flex flex-col gap-8">
            <Text
              tw
              variant="text-xl/leading-normal/semibold"
              className="text-neutral-charcoal mb-2"
            >
              {headerText}
            </Text>
            <div className="space-y-4">
              {template.faqData.map((faq) => (
                <Accordion
                  key={faq.question}
                >
                  <Accordion.Header
                    className="flex items-center gap-3 w-full"
                  >
                    <Text
                      variant="text-sm/leading-normal/medium"
                      className="text-charcoal-500"
                    >
                      {faq.question}
                    </Text>
                  </Accordion.Header>
                  <Accordion.Content>
                    <Text
                      variant="text-sm/leading-normal/normal"
                      className="text-charcoal-500"
                    >
                      {faq.answer}
                    </Text>
                  </Accordion.Content>
                </Accordion>
              ))}
            </div>
          </div>
        </div>
      </section>
    </TailwindWrapper>
  );
};

FAQSection.defaultProps = {
  sectionName: "FAQ section",
  title: "Frequently asked questions",
  text: "We've compiled the most important information to help you get the most out of your experience. Can't find what you're looking for? Contact us.",
  template: "GeneralFAQ",
};

FAQSection.fields = {
  template: {
    type: "select",
    label: "Template",
    options: [
      { label: "Drone FAQ", value: "DroneFAQ" },
      { label: "General FAQ", value: "GeneralFAQ" },
    ],
  },
  sectionName: {
    type: "text",
    label: "Section Name",
  },
  title: {
    type: "text",
    label: "Title",
  },
  text: {
    type: "textarea",
    label: "Description Text",
  },
};

export default FAQSection;
